import React, { useEffect, useState } from "react";
import TablePagination from "@mui/material/TablePagination";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import { Box, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import {
  submitUserRoles,
  downloadUserRoles,
  getUserMaintanenceData,
} from "../../Redux/UserMaintanence";
import "./UserMaintenance.css";
import EditSupervisor from "./EditSupervisor";
import axios from "axios";
import { useInsertionEffect } from "react";
import DeleteItem from "./DeleteItem";
import EmailValidation from "./EmailValidation";
import Alert from '@mui/material/Alert';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#8a2be2",
    color: theme.palette.common.white,
    fontSize: 14,
    textAlign: "center",
    fontFamily: "Graphik-Semibold",
    paddingBottom: 5,
    paddingTop: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "center",
    fontFamily: "Graphik-Regular",
    padding: 13,
  },
}));

const StyledTableCellAbove = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#8a2be2",
    color: theme.palette.common.white,
    fontSize: 14,
    textAlign: "center",
    fontFamily: "Graphik-Semibold",
    paddingTop: 10,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    border: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "center",
    fontFamily: "Graphik-Regular",
    padding: 0,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:first-child td, &:first-child th": {
    border: 0,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:nth-of-type(even)": {
    backgroundColor: "white",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:first-child td, &:first-child th": {
    border: 0,
  },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(5),
    paddingLeft: theme.spacing(15),
    paddingRight: theme.spacing(13),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
    borderColor: "7500c0",
    "&:hover fieldset": {
      borderColor: "#7500c0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#7500c0",
    },
  },
});

function MaintanenceTable({ isAlertSec, setisAlertSec, initData }) {
  const [searchVal, setSearchVal] = useState("");
  // const [filteredData, setFilteredData] = useState(userData);
  const [page, setPage] = useState(0);
  const userData = useSelector((state) => state.userRoles.UserMaintanenceData);
  const userMaintenanceTableError = useSelector((state) => state.userRoles.error);
  // const AxEquippedData = useSelector((state) => state.AXData.AXEquippedData);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [boolChecked, setBoolChecked] = useState(false);
  const [boolCheckedDelete, setBoolCheckedDelete] = useState(false);
  const dispatch = useDispatch();
  const [openEdit, setOpenEdit] = useState(false);
  const [supervisorRowId, setSupervisorRowId] = useState("");
  const [entId, setEntId] = useState("");
  const [editBool, setEditBool] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteEntId, setDeleteEntId] = useState("");
  const [open, setOpen] = React.useState(false);
  const [filteredDone, setFilteredDome] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(userData);
  }, [userData]);

  useEffect(() => {
    setFilteredData(
      userData?.filter((item) =>
        Object.keys(item).some((key) =>
          item["Enterprise_ID"].toLowerCase().includes(searchVal.toLowerCase())
        )
      )
    );
    setFilteredDome(true);
  }, [searchVal]);

  const searchFunction = (e) => {
    setSearchVal(e.target.value);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setisAlertSec(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleOpenEdit = (supervisorName, item) => {
    setOpenEdit(true);
    setSupervisorRowId(supervisorName);
    setEntId(item?.Enterprise_ID);
    // console.log(supervisorName, "suppppeervissor");
    // console.log(item.Enterprise_ID, "Enterprise ID");
  };

  const handleDelete = (enterpriseID, item) => {
    setOpenDelete(true);
    setDeleteEntId(enterpriseID);
    // console.log(enterpriseID, "enterprise id to be deleted");
  };
  useEffect(() => {
    dispatch(getUserMaintanenceData());
    setBoolChecked(false);
    setFilteredData(userData);
  }, [isAlertSec, boolChecked, boolCheckedDelete]);

  const [checkedValues, setCheckedValues] = useState(
    filteredData.map((item) => {
      const { Enterprise_ID, Supervisor, sno, ...rest } = item; // Extract Enterprise_ID and other properties
      const checkedProperties = {};
      Object.keys(rest).forEach((key) => {
        checkedProperties[key] = rest[key] === "yes";
      });
      return {
        Enterprise_ID,
        Supervisor,
        sno,
        ...checkedProperties,
      };
    })
  );
  const handleSubmitClick = () => {
    const mappedArray = checkedValues.map((item) => {
      const mappedItem = {};
      for (const key in item) {
        if (key !== "Enterprise_ID" && key !== "Supervisor") {
          mappedItem[key] = item[key] ? "yes" : "no";
        } else {
          mappedItem[key] = item[key];
        }
      }
      return mappedItem;
    });
    const changedObjects = mappedArray.filter(
      (obj2, index) =>
        !Object.keys(obj2).every(
          (key) => key === "sno" || obj2[key] === userData[index][key]
        )
    );
    const isAdminUser = mappedArray.filter((item, index) => {
      if (item.isActive === 'yes') {
        return !Object.keys(item).every((key) => key === "sno" || item[key] === userData[index][key])
      }
      return item
    }
    )
    console.log('adminUser', isAdminUser)
    dispatch(submitUserRoles(isAdminUser));
    setSearchVal("");
    setisAlertSec(true);
  };
  useEffect(() => {
    setCheckedValues(
      filteredData?.map((item) => {
        const { Enterprise_ID, Supervisor, sno, ...rest } = item; // Extract Enterprise_ID and other properties
        const checkedProperties = {};
        // console.log(rest, "rest values");
        Object.keys(rest).forEach((key) => {
          checkedProperties[key] = rest[key] === "yes";
        });
        return {
          Enterprise_ID,
          Supervisor,
          sno,
          ...checkedProperties,
        };
      })
    );
    setFilteredDome(false);
  }, [filteredData, page, searchVal]);

  const handleCheckboxChange = (objectIndex, property) => {
    console.log(objectIndex, "object Index");
    setCheckedValues((prevValues) => {
      const newValues = [...prevValues];

      let indexOfElem = newValues?.findIndex(
        (item) => item.Enterprise_ID == objectIndex
      );
      // Initialize the object if it doesn't exist
      if (!newValues[indexOfElem]) {
        newValues[indexOfElem] = {};
      }

      newValues[indexOfElem] = {
        ...newValues[indexOfElem],
        [property]: !newValues[indexOfElem][property],
      };
      return newValues;
    });
  };
  const handleDownload = () => {
    dispatch(downloadUserRoles());
  };
  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#7500C0"),
    backgroundColor: "#7500C0",
    marginLeft: "5%",
    "&:hover": {
      backgroundColor: "#7500C0",
      color: "#fff",
    },
  }));

  return (
    <>
      {userMaintenanceTableError && <Alert severity="error" className="errorAlert"><b>Internal Server Error:</b> Please try again with a hard refresh. If the issue persists, contact the LIS team for further assistance.</Alert>}
      <Stack
        sx={{
          width: "90%",
          margin: "auto",
          marginTop: "3%",
        }}
      >
        {console.log(userMaintenanceTableError, "errrrr")}
        <Box
          justifyContent={"start"}
          className="text-filed-box"
          display="flex"
          alignItems={"end"}
        >
          {/* <label for="outlined-start-adornment" className="sr-only">Enter Enterprise ID</label> */}
          <CssTextField
            placeholder="Search by Enterprise ID..."
            id="outlined-start-adornment"
            sx={{ m: 1, width: "30ch", align: "center" }}
            value={searchVal}
            onChange={searchFunction}
            size="small"
            margin="dense"
            InputProps={{
              endAdornment: (
                <IconButton type="submit" sx={{ p: "10px" }} aria-label="search">
                  <SearchIcon />
                </IconButton>
              ),
            }}
          />
        </Box>
        {/* <EmailValidation /> */}
        <TableContainer component={Paper} style={{ maxHeight: 450 }}>
          <Table className="maintanence-table" stickyHeader>
            <TableHead>
              <StyledTableRow style={{ padding: "0px" }}>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>Sl. #</StyledTableCell>
                <StyledTableCell
                  style={{
                    position: "sticky",
                    left: "0",
                    zIndex: "99999",
                  }}
                >
                  Enterprise ID
                </StyledTableCell>
                <StyledTableCell
                  style={{
                    position: "sticky",
                    left: "11%",
                    zIndex: "99999",
                  }}
                >
                  Supervisor
                </StyledTableCell>
                <StyledTableCell style={{ borderLeft: "1px solid white" }}>
                  Automation Engineer</StyledTableCell>
                <StyledTableCell>Backend Developer</StyledTableCell>
                <StyledTableCell>Full Stack Engineer</StyledTableCell>
                <StyledTableCell>System Engineer</StyledTableCell>
                <StyledTableCell>Web Developer</StyledTableCell>
                <StyledTableCell>Admin</StyledTableCell>
                <StyledTableCell>isActive</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {filteredData != undefined &&
                filteredData.length != 0 &&
                filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, rowIndex) =>
                    item.isActive === "yes" ? (
                      <StyledTableRow key={rowIndex}>
                        {/* {console.log(rowIndex, " rowIndex")} */}
                        {Object.keys(item).map((key, cellIndex) => (
                          <StyledTableCell
                            className="table_rows_data"
                            key={cellIndex}
                            style={{
                              position:
                                (key == "Enterprise_ID" || key == "Supervisor") &&
                                "sticky",
                              left:
                                key == "Enterprise_ID"
                                  ? "0px"
                                  : key == "Supervisor"
                                    ? "11%"
                                    : "none",
                              zIndex:
                                (key == "Enterprise_ID" || key == "Supervisor") &&
                                "77777",
                              backgroundColor:
                                item["sno"] % 2 !== 0 ? "#f5f5f5" : "#fff",
                              minWidth:
                                (key == "Enterprise_ID" || key == "Supervisor") &&
                                "150px",
                              maxWidth: "160px",
                              overflowWrap: "break-word",
                            }}
                            width={key == "Enterprise_ID" && 1200}
                          >
                            {key === "Enterprise_ID" || key == "sno" ? (
                              item[key]
                            ) : key == "Supervisor" ? (
                              <>
                                {item[key]}{" "}
                                <span
                                  className="supervisor-pencil"
                                  onClick={() => handleOpenEdit(item[key], item)}
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/images/UserMaintenance/pencil_icon.png"
                                    }
                                    alt=""
                                    className="pencil-img"
                                  />
                                </span>
                              </>
                            ) : (
                              <Checkbox
                                checked={
                                  checkedValues.filter(
                                    (jojo) => jojo.sno == item["sno"]
                                  )[0]?.[key] || false
                                }
                                onChange={
                                  () =>
                                    handleCheckboxChange(
                                      item["Enterprise_ID"],
                                      key
                                    )
                                }
                                color="success"
                                inputProps={{ "aria-label": "controlled" }}
                              />
                            )}
                          </StyledTableCell>
                        ))}
                      </StyledTableRow>
                    ) : (
                      <StyledTableRow key={rowIndex}>
                        {Object.keys(item).map((key, cellIndex) => (
                          <StyledTableCell
                            key={cellIndex}
                            style={{
                              position:
                                (key == "Enterprise_ID" || key == "Supervisor") &&
                                "sticky",
                              left:
                                key == "Enterprise_ID"
                                  ? "0px"
                                  : key == "Supervisor"
                                    ? "11%"
                                    : "none",
                              zIndex:
                                (key == "Enterprise_ID" || key == "Supervisor") &&
                                "77777",
                              backgroundColor:
                                item["sno"] % 2 !== 0 ? "#f5f5f5" : "#fff",
                              minWidth:
                                (key == "Enterprise_ID" || key == "Supervisor") &&
                                "150px",
                              maxWidth: "160px",
                              overflowWrap: "break-word",
                            }}
                          >
                            {key === "Enterprise_ID" || key == "sno" ? (
                              item[key]
                            ) : key == "Supervisor" ? (
                              <>
                                {item[key]}{" "}
                                <span
                                  className="supervisor-pencil"
                                  onClick={() => handleOpenEdit(item[key], item)}
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/images/UserM/pencil_icon.png"
                                    }
                                    alt=""
                                    className="pencil-img"
                                  />
                                </span>
                              </>
                            ) : key == "isActive" ? (
                              <>
                                <Checkbox
                                  checked={
                                    checkedValues.filter(
                                      (jojo) => jojo.sno == item["sno"]
                                    )[0]?.[key] || false
                                  }
                                  onChange={() =>
                                    handleCheckboxChange(
                                      item["Enterprise_ID"],
                                      key
                                    )
                                  }
                                  color="success"
                                  inputProps={{ "aria-label": "controlled" }}
                                />
                                <span
                                  className="supervisor-pencil"
                                  onClick={() =>
                                    handleDelete(item["Enterprise_ID"], item)
                                  }
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/images/UserMaintenance/delete_icon.jpeg"
                                    }
                                    alt=""
                                    style={{ width: "25px" }}
                                    className="pencil-img"
                                  />
                                </span>
                              </>
                            ) : (
                              <>
                                <Checkbox
                                  checked={
                                    checkedValues.filter(
                                      (jojo) => jojo.sno == item["sno"]
                                    )[0]?.[key] || false
                                  }
                                  onChange={() =>
                                    handleCheckboxChange(
                                      item["Enterprise_ID"],
                                      key
                                    )
                                  }
                                  color="success"
                                  disabled
                                  inputProps={{ "aria-label": "controlled" }}
                                />
                              </>
                            )}
                          </StyledTableCell>
                        ))}
                      </StyledTableRow>
                    )
                  )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[15, 25, 100]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <div style={{ marginBottom: "4%" }}>
          <Stack justifyContent={"center"} spacing={2} direction={"row"}>
            <ColorButton
              variant="contained"
              size="small"
              onClick={handleSubmitClick}
            >
              Submit
            </ColorButton>
            <ColorButton
              variant="contained"
              size="small"
              onClick={handleDownload}
            >
              Download
            </ColorButton>
          </Stack>
        </div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={isAlertSec}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <Typography gutterBottom style={{ marginTop: "50px" }}>
              {/* The role has been updated. */}
              Your changes are saved
            </Typography>
          </DialogContent>
          <DialogActions>
            <ColorButton
              variant="contained"
              className="cancel-button"
              size="small"
              sx={{
                background: "white",
                color: "#7500C0",
                border: "solid 1px #7500C0",
                marginRight: "40%",
              }}
              autoFocus
              onClick={handleClose}
            >
              Ok
            </ColorButton>
          </DialogActions>
        </BootstrapDialog>
        <EditSupervisor
          openEdit={openEdit}
          setOpenEdit={setOpenEdit}
          supervisorRowId={supervisorRowId}
          entId={entId}
          setBoolChecked={setBoolChecked}
        />
        <DeleteItem
          openDelete={openDelete}
          setOpenDelete={setOpenDelete}
          deleteEntId={deleteEntId}
          setBoolCheckedDelete={setBoolCheckedDelete}
        />
      </Stack>
    </>
  );
}

export default MaintanenceTable;
